import { Routing } from "routes";
import { RecoilRoot } from "recoil";
import { ConfigProvider } from "antd";
import { CurrentUserProvider } from "providers";
import "./App.scss";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

function App() {
  const queryClient = new QueryClient();
  document.title = `Motion2Coach ${process.env.REACT_APP_env === "dev" ? "Dev" : ""}`;

  return (
    <div className="light">
      <CurrentUserProvider>
        <ConfigProvider
          theme={{
            components: {
              Table: {
                cellPaddingBlock: 14,
              },
              Menu: {
                itemSelectedBg: "#E7F1F8",
                itemSelectedColor: "#006AB3",
                itemHeight: 40,
                padding: 0,
              },
            },
          }}
        >
          <RecoilRoot>
            <QueryClientProvider client={queryClient}>
              <Routing />
            </QueryClientProvider>
          </RecoilRoot>
        </ConfigProvider>
      </CurrentUserProvider>
    </div>
  );
}

export default App;
